import {hideElement, showElement} from "./element-visibility";
import {sendForm} from "./form";
import {isMobile} from "./devices";

export function checkEmail(form)
{
    let email = form.querySelector('input[name="email"]').value;

    sendForm(
        form,
        function(data) {
            let exists = data.exists;
            document.querySelectorAll('.access-form input[type="email"], .access-form input[name="repeat-email"]').forEach(function(input) {
                input.value = email;
            });
            hideElement(document.querySelector('#form-check-email-container'));
            if (exists) showElement(document.querySelector('#form-login-container'));
            else showElement(document.querySelector('#form-register-container'));
        }
    );
}

export function sendLogin(form)
{
    let errorResponse = form.querySelector('.error-response');
    slideUp(errorResponse);
    sendForm(
        form,
        function(data) {
            let access = form.closest('.access-content');
            dataLayer.push(
                {
                    "event": "login",
                    "method": "form"
                }
            );
            window.location = access.querySelector('input[name="redirectUrl"]').value;
        },
        function(data) {
            errorResponse.innerHTML = data.message;
            slideDown(errorResponse);
            if (isMobile()) window.scrollTo({top: 0, behavior: 'smooth'});
        }
    );
}

export function sendRecoverPassword(form)
{
    let successResponse = form.querySelector('.success-response');
    let errorResponse = form.querySelector('.error-response');
    let access = form.closest('.access-content');
    slideUp(successResponse);
    slideUp(errorResponse);
    sendForm(
        form,
        function(data) {
            successResponse.innerHTML = data.message;
            slideDown(successResponse);
            setTimeout(function() {
                slideUp(successResponse);
                closeRecoverPasswordForm(access);
            }, 4000);
        },
        function(data) {
            errorResponse.innerHTML = data.message;
            slideDown(errorResponse);
            if (isMobile()) {
                window.scrollTo({top: 0, behavior: 'smooth'});
            }
        }
    );
}

export function sendRegister(form)
{
    let errorResponse = form.querySelector('.error-response');
    slideUp(errorResponse);
    sendForm(
        form,
        function(data) {
            dataLayer.push(
                {
                    "event": "sign_up",
                    "method": "form"
                }
            );
            location.reload();
        },
        function(data) {
            errorResponse.innerHTML = data.message;
            slideDown(errorResponse);
            if (isMobile()) window.scrollTo({top: 0, behavior: 'smooth'});
        }
    );
}

export function openRecoverPasswordForm(access)
{
    hideElement(access.querySelector('.login-form-container'));
    if (isMobile()) window.scrollTo({top: 0, behavior: 'smooth'});
    showElement(access.querySelector('.recover-password-form-container'));
    access.dataset.current = 'recover-password';
}

export function closeRecoverPasswordForm(access)
{
    hideElement(access.querySelector('.recover-password-form-container'));
    showElement(access.querySelector('.login-form-container'));
    if (isMobile()) window.scrollTo({top: 0, behavior: 'smooth'});
    access.dataset.current = 'login';
}

export function openRegisterForm(access)
{
    slideUp(access.querySelector('.login-form-container'), 200, function() {
        if (isMobile()) window.scrollTo({top: 0, behavior: 'smooth'});
        slideDown(access.querySelector('.register-form-container'), 200, function() {
            access.dataset.current = 'register';
            google.accounts.id.renderButton(
                access.querySelector('.register-form-container').querySelector('.g_id_signin'),
                { type: "icon", size: "large", theme: "outline" }  // customization attributes
            );
        });
    });
}

export function closeRegisterForm(access)
{
    slideUp(access.querySelector('.register-form-container'), 200, function() {
        if (isMobile()) window.scrollTo({top: 0, behavior: 'smooth'});
        slideDown(access.querySelector('.login-form-container'), 200, function() {
            access.dataset.current = 'login';
            google.accounts.id.renderButton(
                access.querySelector('.login-form-container').querySelector('.g_id_signin'),
                { type: "icon", size: "large", theme: "outline" }  // customization attributes
            );
        });
    });
}